import api from './http';
import { Job } from '../types/api';

export interface JobFilters {
  status?: 'pending' | 'in_progress' | 'completed' | 'cancelled';
  store_id?: number;
  scheduled_from?: string;
  scheduled_to?: string;
}

export const fetchJobs = async (filters?: JobFilters): Promise<Job[]> => {
  const { data } = await api.get<Job[]>('/jobs', { params: filters });
  return data;
};

export const fetchJobById = async (jobId: string | number): Promise<Job> => {
  const { data } = await api.get<Job>(`/jobs/${jobId}`);
  return data;
};

// Re-export Job type for convenience
export type { Job };

